import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

import Page from './Page';
import Translation from './Translation';

function renderItem({title, text, safetytype}, index) {
	return (
		<li className="slx-mounting-safety__item" key={index}>
			<img
				className="slx-mounting-safety__item-icon"
				src={`/assets/images/safety-icons/${safetytype}.svg`}
				alt={safetytype}
				/>
			<div className="slx-mounting-safety__item-content">
				<h3 className="slx-mounting-safety__item-title">{title}</h3>
				<div className="slx-mounting-safety__item-text" dangerouslySetInnerHTML={{__html: text}} />
			</div>
		</li>
	);
}

function Safety({facets, content, startPageNumber, maxPageNumber}) {
	const {safetyItems, cleaningItems} = content;

	const maxitemsperpage = 16;
	let safetyItems1;
	let safetyItems2;

	if (safetyItems && safetyItems.length > 0) {
		safetyItems1 = safetyItems.slice(0); // clone original
		safetyItems2 = safetyItems1.splice(maxitemsperpage); // splice the clone
	}

	return (
		<Fragment>
			{safetyItems1 &&
				<Page
					content={content}
					number={startPageNumber}
					maxPageNumber={maxPageNumber}
				>
					<div className="slx-mounting-safety">
						<h1 className="slx-mounting-safety__title">
							<Translation name="essential-safety-instructions" />
						</h1>

						<ul className="slx-mounting-safety__list">
							{safetyItems1.map(renderItem)}
						</ul>
						<div className="slx-mounting-safety__note">
							<Translation name="save-these-instructions" />
						</div>
					</div>
				</Page>
			}

			{(cleaningItems || safetyItems2) &&
				<Page
					content={content}
					number={startPageNumber + !!safetyItems}
					maxPageNumber={maxPageNumber}
				>
					<div className="slx-mounting-safety">
						<h1 className="slx-mounting-safety__title">
							<Translation name="essential-safety-instructions"/>
						</h1>

						{safetyItems2 &&
							<span>
								<ul className="slx-mounting-safety__list">
									{safetyItems2.map(renderItem)}
								</ul>
							</span>
						}

						{cleaningItems &&
							<span>
								<h2 className="slx-mounting-safety__subtitle">
									<Translation name="cleaning-of-luminaire"/>
								</h2>
								<ul className="slx-mounting-safety__list">
									{cleaningItems.map(renderItem)}
								</ul>
							</span>
						}

					</div>
				</Page>
			}
		</Fragment>
	);
}

Safety.propTypes = {
	facets: PropTypes.object.isRequired,
	content: PropTypes.object.isRequired,
	startPageNumber: PropTypes.number.isRequired,
	maxPageNumber: PropTypes.number.isRequired,
};

export default React.memo(Safety);

export function numPages(state) {
	return ['safetyItems', 'cleaningItems']
		.filter(e => state.content[e])
		.length;
}
